import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { RadioModule } from 'z3k-config';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { DragDropDrawer } from '../../../utils/drag-drop-drawer/component';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
export function RadioSensors433List(props) {
    const { config } = useContext(Z3KSettingsEditor);
    const radioModule433 = RadioModule.get.some(config, RadioModule.isBuiltinRadioModule433);
    if (radioModule433 == null) {
        return null;
    }
    return (_jsx(DragDropDrawer, { z3k_name: "radiosensors433", name: RouteNaming[Z3kSecondRoutes.radiosensor433], help_id: "radiosensors433", item_url: Z3kSecondRoutes.radiosensor433, hideAddButton: true, enableDnd: true, ...props }));
}
